// extracted by mini-css-extract-plugin
export default {"container":"List_container__mVMeq","empty":"List_empty__-mbaz","skeleton":"List_skeleton__UG7mX"};